import { QRCodeCanvas } from "qrcode.react";
import { CalendarClock, Download } from "lucide-react";
import { FREE_SONG_KEY, FREE_SONG_EXPIRY } from "@/lib/catalog";

export default function QrPage() {
  const vaultUrl = `${window.location.origin}/vault/${FREE_SONG_KEY}`;

  const downloadQr = () => {
    const canvas = document.querySelector('[data-testid="qr-code"] canvas');
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = "pixels-and-glass-free-qr.png";
    a.click();
  };

  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center px-6 grain">
      <div className="max-w-md w-full text-center fade-up">
        <span className="font-mono-ui text-xs uppercase tracking-[0.3em] text-primary-gold">
          Private · For the Author
        </span>
        <h1 className="font-serif-display text-4xl font-semibold mt-6">Free Song QR Code</h1>
        <p className="text-soft mt-4 text-sm">
          Print or share this QR. Anyone who scans it gets a free download of "Pixels and Glass".
        </p>

        <div className="bg-white p-6 inline-block mt-10" data-testid="qr-code">
          <QRCodeCanvas value={vaultUrl} size={240} level="H" includeMargin={false} />
        </div>

        <div className="mt-6">
          <button
            onClick={downloadQr}
            data-testid="download-qr-button"
            className="btn-ghost inline-flex items-center gap-2 px-6 py-3 font-mono-ui text-xs uppercase tracking-[0.18em]"
          >
            <Download className="w-4 h-4" /> Download QR (PNG)
          </button>
        </div>

        <div className="mt-6 inline-flex items-center gap-2 border border-primary-gold/30 bg-primary-gold/5 px-4 py-2.5" data-testid="qr-expiry">
          <CalendarClock className="w-4 h-4 text-primary-gold" />
          <span className="font-mono-ui text-xs uppercase tracking-[0.18em] text-primary-gold">
            Expires {FREE_SONG_EXPIRY}
          </span>
        </div>

        <div className="mt-8 border border-white/10 bg-[#121212] p-4">
          <p className="font-mono-ui text-xs uppercase tracking-[0.2em] text-soft mb-2">
            Secret link
          </p>
          <p className="font-mono-ui text-sm text-primary-gold break-all" data-testid="vault-url">
            {vaultUrl}
          </p>
        </div>
      </div>
    </div>
  );
}
